import { isInHeybox, getOSType, getUrlParam } from '_lib/utils';
import { HbToast } from '@heybox-components/heybox-ui';
import { getShareInfo } from '_api/wx_share';
import { reportDataWeb } from '_api/web-report';

export const WEIXIN_APPID = 'wxe8989eb8b38b5c4d';
export const TENCENT_STORE_URL = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.max.xiaoheihe'
export const APP_STORE_URL = 'https://itunes.apple.com/cn/app/id1244505010'
export const DEFAULT_SHARE_CONFIG = {
  title: '小黑盒',
  desc: '高能玩家聚集地',
  link: window.location.href,
  imgUrl: 'https://cdn.max-c.com/heybox/logo/app_251.png',
}

/**
 * 获取客户端类型，返回值为 heybox | weixin | qq | other
 */
export const getAppType = () => {
  const ua = navigator.userAgent.toLowerCase();
  if (isInHeybox()) {
    return 'heybox'
  } else if (/MicroMessenger/i.test(ua)) {
    return 'weixin'
  } else if (/QQ/i.test(ua)) {
    return 'qq'
  } else if (/weibo/i.test(ua)) {
    return 'weibo'
  } else {
    return 'other'
  }
}

/**
 * 获取操作系统类型
 */
export { getOSType };

/**
 * 判断是否可以使用微信深度链接
 */
export function judgeCanUseDeepLink() {
  if (isInHeybox()) {
    return false
  }
  // 微信版本号大于 7.0.12 开放标签才可进行 唤醒 app 跳转
  const wechatInfo = window.navigator.userAgent.match(
    /MicroMessenger\/([\d\.]+)/i,
  );
  if (!wechatInfo) return false;
  let judgewechat = wechatInfo[1].split('.');
  if (judgewechat[0] >= 7 && judgewechat[1] >= 0 && judgewechat[2] >= 12) {
    return true;
  } else {
    return false;
  }
}

/**
 * 申请微信授权
 */
export async function requestWeixinConfig() {
  const {
    data: {
      status,
      result: weixinConfig
    }
  } = await getShareInfo({
    url: window.location.href // INFO 后台会进行域名校验，不匹配会触发 invalid signature签名错误
  });
  if (status == 'ok') {
    return weixinConfig;
  }
  return null;
}

export function parseObjectProtocol(protocol = {}) {
  if (typeof protocol == 'string') {
    const decodeProtocol = decodeURIComponent(protocol);
    if (decodeProtocol.startsWith('heybox://')) {
      return JSON.parse(decodeProtocol.replace('heybox://', ''));
    } else {
      showLog(`协议格式不合法: ${decodeProtocol}`);
    }
  }
  return protocol;
}

export function showLog(text, showTip = false) {
  console.log('🔥log:', text);
  if (showTip) {
    HbToast.tip({
      text: typeof text == 'object' ? JSON.stringify(text) : text,
      duration: 3000,
      clickThrough: true,
    });
  }
}

/**
 * 打开深度链接，只有iOS支持
 */
export function openDeepLink(protocolObject) {
  const host = getUrlParam('client_type') == 'acc_mobile' ? 'acc.xiaoheihe.cn' : 'c.xiaoheihe.cn';
  const link = `https://${host}/hb_protocol?protocol=heybox://${encodeURIComponent(JSON.stringify(protocolObject))}`;
  window.location.href = link;
}

/**
 * 执行 schema 跳转
 */
export function openSchema(protocolObject) {
  window.location.href = `heybox://${encodeURIComponent(JSON.stringify(protocolObject))}`;
}

/**
 * 打开 apple App Store
 */
export function openAppStore() {
  window.location.href = APP_STORE_URL;
}

/**
 * 打开腾讯应用宝
 */
export function openTencentStore(protocolObject) {
  const link = `${TENCENT_STORE_URL}&${getOSType() == 'Android' ? 'android' : 'ios'}_schema=${encodeURIComponent('heybox://' + JSON.stringify(protocolObject))}`;
  window.location.href = link;
}

/**
 * 打开过渡页
 */
export function openTransitionPage(protocolObject) {
  window.location.href = `https://api.xiaoheihe.cn/open_inapp/#heybox://${encodeURIComponent(JSON.stringify(protocolObject))}`;
}


export function isDev() {
  return process.env.NODE_ENV == 'development';
}

/**
 * 上报分享数据
 * @returns
 */
export const reportShare = ({
  action = 'visit', // 行为, visit, click_open, download
  page_identifier = '', // 额外信息
  open_source = window.location.pathname, // 标识业务
}) => {
  if (!action) {
    return;
  }
  const params = {
    path: `/web_share/${action}`,
    type: '1',
    addition: {
      open_source,
      page_identifier,
    },
  };
  console.log('🚀 ~ share params:', params);
  reportDataWeb(params);
};

/**
 * 上报访问
 */
export const reportVisitAction = (() => {
  const _reportVisitSet = new Set();
  return (protocolObject) => {
    const { open_source, page_identifier } = protocolObject;
    const key = `${open_source}-${page_identifier}`;
    if (_reportVisitSet.has(key)) {
      return;
    }
    _reportVisitSet.add(key);
    reportShare({
      action: 'visit',
      open_source,
      page_identifier,
    });
  };
})();


/**
 * 上报点击打开
 */
export const reportClickOpen = (protocolObject) => {
  reportShare({
    ...protocolObject,
    action: 'click_open',
  });
}